import React, {useMemo, Fragment} from 'react';
import {Listbox, Transition} from "@headlessui/react";
import {CheckIcon, ChevronUpDownIcon} from "@heroicons/react/24/solid";
import {classNames, getAccountImageUrl} from "../../../utils/common";

const AccountPicker = ({label, account, setAccount, accounts, smallerSize = false, emptyText = '', ...props}) => {
    const selectorAccountWidth = useMemo(() => {
        let maxWidth = 1;
        accounts.forEach(account => {
            let accountWidth = account.name.length * 8;
            if (accountWidth > maxWidth) {
                maxWidth = accountWidth;
            }
        });
        return maxWidth + (smallerSize ? 60 : 100) + 'px';
    }, [accounts, smallerSize]);

    return (
        <Listbox as="div" value={account || ''} onChange={setAccount} {...props}>
            {({ open }) => (
                <>
            {label && <Listbox.Label className={classNames(
                smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                "block font-medium text-gray-700"
            )}> {label}</Listbox.Label>}
            <div className={classNames(smallerSize ? "mt-0.5 h-7" : "mt-1 h-10", "relative")}>
                <Listbox.Button className={classNames(
                    smallerSize
                        ? "h-7 pl-1.5 pr-1.5 py-1 text-xs"
                        : "h-10 pl-3 pr-3 py-2 text-sm",
                    "relative bg-white border border-gray-300 rounded-md shadow-sm text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                )}
                               style={{minWidth: selectorAccountWidth}}>
                <span className="flex justify-between">
                    <span className="flex items-center block">
                        {account && <img src={getAccountImageUrl(account.logo)} alt="" className={classNames(
                            smallerSize ? "h-4 w-4" : "h-6 w-6",
                            "flex-shrink-0 rounded-full"
                        )}/>}
                        {account && <span className={classNames(smallerSize ? "ml-1" : "ml-3", "block whitespace-nowrap truncate")}>{account.name}</span>}
                        {!account && emptyText && <span className={classNames(smallerSize ? "ml-1" : "ml-3", "block whitespace-nowrap")}>{emptyText}</span>}
                    </span>
                    <span className={classNames(smallerSize ? "ml-1" : "ml-3", "block flex items-center pointer-events-none")}>
                        <ChevronUpDownIcon className={classNames(smallerSize ? "h-4 w-4" : "h-5 w-5", "text-gray-400")} aria-hidden="true"/>
                    </span>
                </span>
                </Listbox.Button>

                <Transition
                    show={open}
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Listbox.Options className={classNames(
                        smallerSize ? "text-xs" : "text-base sm:text-sm",
                        "absolute z-10 mt-1 w-full bg-white shadow-lg max-h-96 rounded-md py-1 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none"
                    )}>
                        {accounts.map((accountOption) => (
                            <Listbox.Option
                                key={accountOption.id}
                                className={({ active }) =>
                                    classNames(active
                                            ? 'bg-indigo-600 text-white'
                                            : 'text-gray-900',
                                        smallerSize ? 'py-1 pl-2 pr-7' : 'py-2 pl-3 pr-9',
                                        'relative cursor-default select-none')
                                }
                                value={accountOption}
                            >
                                {({ selected, active }) => (
                                    <>
                                        <div className="flex items-center">
                                            <img src={getAccountImageUrl(accountOption.logo)} alt="" className={classNames(
                                                smallerSize ? "h-4 w-4" : "h-6 w-6",
                                                "flex-shrink-0 rounded-full"
                                            )}/>
                                            <span className={classNames(
                                                selected ? 'font-semibold' : 'font-normal',
                                                smallerSize ? 'ml-1' : 'ml-3',
                                                'block truncate'
                                            )}>
                                                {accountOption.name}
                                            </span>
                                        </div>
                                        {selected && <span className={classNames(
                                            active ? 'text-white' : 'text-indigo-600',
                                            smallerSize ? 'pr-2' : 'pr-4',
                                            'absolute inset-y-0 right-0 flex items-center'
                                        )}>
                                            <CheckIcon className={classNames(smallerSize ? "h-4 w-4" : "h-5 w-5")} aria-hidden="true"/>
                                        </span>}
                                    </>
                                )}
                            </Listbox.Option>)
                        )}
                    </Listbox.Options>
                </Transition>
            </div>
                </>)}
        </Listbox>
    );
};

export default AccountPicker;
